/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit BackAction/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import ButtonIconSquare from 'DesignSystem/ButtonIconSquare/index'
import React from 'react'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function BackAction({
  children,
  viewPath = "/App/Account/MonthOfBirth/BackAction"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<ButtonIconSquare
  viewPath={`${viewPath}/ButtonIconSquare`}
 marginRight={20}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../DayOfBirth'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../../DayOfBirth'))}
/>
{children}
</React.Fragment>)
}